import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useActiveLinks = () => {
    const location = useLocation();
    
    const links = useMemo(() => {
        const path = location.pathname;
        
        // Object avec tous les liens initialisés à false
        const baseLinks = {
            linkOne: false, 
            linkTwo: false, 
            linkThree: false, 
            linkFour: false,
            linkFive: false, 
            linkSix: false, 
            linkSeven: false, 
            linkEight: false,
            linkNine: false,
            linkTen: false,
        };

        // Mapping plus lisible entre les paths et les liens
        const pathToLinkMap = {
            '/ilmondodeiviniabruzzese': 'linkOne',
            '/sceglierebeneivini': 'linkTwo',
            '/degustazionedeivini': 'linkThree',
            '/provincedellabruzzo': 'linkFour',
            '/tipologiainabruzzo': 'linkFive',
            '/vitignoinabruzzo': 'linkSix',
            '/ilmondodeiviniabruzzese/eventiEnogastronomoci': 'linkSeven',
            '/sagredellabruzzo': 'linkEight',
            '/negozioonline': 'linkNine',
            '/enoquizabruzzo': 'linkTen',
        };

        const activeLink = pathToLinkMap[path];
        
        if (activeLink) {
            return { ...baseLinks, [activeLink]: true };
        }
        
        return baseLinks;
    }, [location.pathname]);

    return links;
};

